module.exports = __webpack_public_path__ + "img/Screenshot_data.da31641c.svg";